import { removeFriend } from "../../utils/helper"
import { useAuth } from "../../contexts/AuthContext"
import avatar from "../../assets/images/avatar.png"
import cross from '../../assets/images/svg/cross'


const FriendCard = ({ friend, handleClick }) => {
  const { currentUser } = useAuth()
  const handleRemoveFriend = (e) => {
    e.preventDefault()
    removeFriend(currentUser.user.uid, friend.id)
  }

  return (
    <div id={friend.id} data-pseudo={friend.data().pseudo} className="userCard" >
      <i onClick={handleRemoveFriend}>
        {cross}
      </i>
      <img alt="" src={friend.data()?.image ?? avatar} className="rounded-full w-32" />
      <h2 className="font-bold mt-3 text-darkOrange mx-auto text-[1.1em] mb-3">
        {friend.data().pseudo}
      </h2>
      <button className="friendsButtonStyle gradient mb-2" onClick={handleClick}>
        Voir la liste
      </button>
    </div>
  )
}

export default FriendCard
